import { HttpClient } from "@angular/common/http";
import { APP_BASE_HREF } from "@angular/common";
import { Inject, Injectable } from "@angular/core";
import { map, Observable, catchError, of } from "rxjs";

import { HttpServiceBase, OperationError } from "@indusoft/angular-base-services";

import { ConfigurationHttpService } from "../../../../common/services/configuration.service";
import { LogInRequest, LogInResponse } from "./dtos/login-request";
import { RoutesGlossary } from "../../../../common/glossary/routes-glossary";
import { LogInAasResponse } from "./dtos/login-aas-response";
import { LogOutResponse } from "./dtos/logout-response";

@Injectable()
export class AuthHttpService extends HttpServiceBase {
    protected serviceUrl: string;

    constructor(http: HttpClient,
        @Inject(APP_BASE_HREF) public baseHref: string,
        private config: ConfigurationHttpService) {
        super(http);
    }

    public logIn(userName: string, passwordEncrypted: string, rememberMe: boolean): Observable<LogInResponse> {
        const url = this.config.getFullUrl(RoutesGlossary.Login);
        const request = new LogInRequest(userName, passwordEncrypted, rememberMe);

        return this.httpPost<LogInRequest, LogInResponse>(url, request, "Произошла ошибка при аутентификации!")
            .pipe(
                map(response => {
                    if (response instanceof OperationError)
                        return null;
                    return response;
                })
            );
    }

    public logInAas(): Observable<LogInAasResponse | OperationError> {
        const url = this.config.getFullUrl(RoutesGlossary.Login);
        return this.http.post<LogInAasResponse>(url, {})
            .pipe(
                map(response => response as LogInAasResponse),
                catchError(error => {
                    const operationError = new OperationError(error.message || 'Неизвестная ошибка');
                    operationError.serverError = error;
                    return of(operationError);
                })
            );
    }

    public logOut(): Observable<LogOutResponse> {
        const url = this.config.getFullUrl(RoutesGlossary.Logout);
        return this.http.get<LogOutResponse>(url);
    }
}
